import Vue from 'vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
export default Vue.extend({
    data() {
        return {
            changiRecommendsUrl: 'https://sandbox.changirecommends.com',
            attractionsUrl: 'https://tripplanner.changirecommends.com',
            changiAssureUrl: 'https://changiassure.changitravel.tech',
            fxUrl: 'https://fx.changitravel.tech',
            changiMobileUrl: 'https://mvno2.helperfit.com',
        };
    },
});
